
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

const classNames = mergeStyleSets({
    AuthLinks: {
        padding: 16
    },
});

const AuthLinks = ({children}) => {
    return (
        <Stack className={classNames.AuthLinks} tokens={{childrenGap: 4}}>
            {React.Children.map(children, item => {
                return (
                    <Stack.Item>
                        {item}
                    </Stack.Item>
                );
            })}
        </Stack>
    );
}

export default AuthLinks;
